export const getStringLenth = (str) => {
    let len = 0;

    if (!str) return len;

    // for (let i = 0; i < str.length; i++) {
    //     const c = str.charCodeAt(i);

    //     // 单字节加1
    //     if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
    //         len++;
    //     } else {
    //         len += 2;
    //     }
    // }

    return str.toString().length;
};

export const getDomDistance = (dom) => {
    let left = 0;
    let top = 0;

    while (dom) {
        left += dom.offsetLeft;
        top += dom.offsetTop;
        dom = dom.offsetParent;
    }

    return {
        left,
        top,
    };
};

const isfastmode = () => {
    return (() => {
        let isfastmode = 1;

        try {
            localStorage.setItem('checkfastmode', 1);
            isfastmode = 0;
        } catch (e) {
            console.error(e);
        }

        return isfastmode;
    })();
};

export const setlocal = (key, value) => {
    if (isfastmode()) return '';
    localStorage.setItem(key, JSON.stringify(value));
};

export const getlocal = (key) => {
    if (isfastmode()) return '';

    return JSON.parse(localStorage.getItem(key));
};

// 获取URL查询参数
export const getQuery = (url, key) => {
    let value = '';

    try {
        const urlObj = new URL(url);
        const { searchParams } = urlObj;

        if (searchParams.has(key)) {
            value = searchParams.get(key);
        }
    } catch (e) {
        console.error(e);
    }

    return value;
};
